export default "__VITE_ASSET__BM8qo0kl__"